module.exports = __webpack_public_path__ + "static/media/busyLocationMarker.2fdb9e32.svg";